module.exports = __webpack_public_path__ + "img/intro-preview.c9902044.jpg";